// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.member-detail-container {
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
}

.member-detail-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 20px;
}

.btn-back {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #007bff;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.2s;
}

.btn-back:hover {
  color: #0056b3;
}

.header-titles {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.member-breadcrumb {
  font-size: 13px;
  color: #6b7280;
}

.member-breadcrumb a {
  color: #2563eb;
  text-decoration: none;
}

.member-breadcrumb a:hover {
  text-decoration: underline;
}

.breadcrumb-sep {
  color: #9ca3af;
}

.member-detail-header h2 {
  font-size: 28px;
  font-weight: 600;
  color: #333;
  margin: 0;
}

.header-actions {
  display: flex;
  gap: 10px;
}

.member-detail-card {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  padding: 30px;
}

.profile-section {
  display: flex;
  align-items: center;
  gap: 30px;
  padding-bottom: 30px;
  margin-bottom: 30px;
  border-bottom: 2px solid #e9ecef;
}

.profile-photo {
  width: 150px;
  height: 150px;
  border-radius: 50%;
  object-fit: cover;
  border: 4px solid #e9ecef;
}

.profile-photo-placeholder {
  width: 150px;
  height: 150px;
  border-radius: 50%;
  background-color: #e9ecef;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 60px;
  color: #6c757d;
  border: 4px solid #dee2e6;
}

.profile-info h3 {
  font-size: 32px;
  font-weight: 600;
  color: #333;
  margin: 0 0 8px 0;
}

.profile-info .english-name {
  font-size: 20px;
  color: #666;
  margin: 0 0 4px 0;
}

.profile-info .member-nickname {
  font-size: 14px;
  color: #6b7280;
  margin: 0 0 10px 0;
}

.profile-info .badge {
  margin: 0 8px 10px 0;
}

.profile-info .member-role-badge {
  background: #e0f2fe;
  color: #0369a1;
}

.profile-info .member-number {
  font-size: 14px;
  color: #666;
  margin: 10px 0 0 0;
}

.profile-info .member-org-line {
  font-size: 13px;
  color: #666;
  margin: 4px 0 0 0;
  line-height: 1.35;
}

.profile-info .member-org-group {
  font-size: 16px;
}

.profile-info .member-org-group .member-org-value {
  font-size: 16px;
  font-weight: 600;
}

.profile-info .member-org-label {
  margin-right: 4px;
  color: #6b7280;
}

.profile-info .member-org-value {
  color: #1f2937;
  font-weight: 500;
}

.info-value-email,
.info-row-email .info-value {
  font-size: 12px;
  color: #6b7280;
}

.profile-info .member-groups-text {
  font-size: 11px;
  font-weight: 400;
  word-break: break-all;
}

.badge {
  display: inline-block;
  padding: 6px 12px;
  border-radius: 12px;
  font-size: 13px;
  font-weight: 500;
  text-transform: capitalize;
}

.badge-success {
  background-color: #28a745;
  color: white;
}

.badge-secondary {
  background-color: #6c757d;
  color: white;
}

.badge-warning {
  background-color: #ffc107;
  color: #212529;
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 30px;
  margin-bottom: 30px;
}

.info-section {
  background: #f8f9fa;
  padding: 20px;
  border-radius: 6px;
}

.info-section h4 {
  font-size: 18px;
  font-weight: 600;
  color: #495057;
  margin: 0 0 15px 0;
  padding-bottom: 10px;
  border-bottom: 2px solid #dee2e6;
}

.info-row {
  display: flex;
  padding: 10px 0;
  border-bottom: 1px solid #e9ecef;
}

.info-row:last-child {
  border-bottom: none;
}

.info-label {
  font-weight: 500;
  color: #666;
  min-width: 150px;
  flex-shrink: 0;
}

.info-value {
  color: #333;
  word-break: break-word;
}

.info-value a {
  color: #007bff;
  text-decoration: none;
}

.info-value a:hover {
  text-decoration: underline;
}

.notes-section {
  background: #f8f9fa;
  padding: 20px;
  border-radius: 6px;
  margin-bottom: 20px;
}

.notes-section h4 {
  font-size: 18px;
  font-weight: 600;
  color: #495057;
  margin: 0 0 15px 0;
}

.notes-section p {
  color: #333;
  line-height: 1.6;
  margin: 0;
  white-space: pre-wrap;
}

.system-info {
  padding-top: 20px;
  border-top: 1px solid #e9ecef;
  text-align: center;
}

.system-info small {
  color: #6c757d;
  font-size: 13px;
}

.btn {
  padding: 10px 20px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  border: none;
  transition: all 0.2s;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  text-decoration: none;
}

.btn-primary {
  background-color: #007bff;
  color: white;
}

.btn-primary:hover {
  background-color: #0056b3;
}

.btn-warning {
  background-color: #ffc107;
  color: #212529;
}

.btn-warning:hover {
  background-color: #e0a800;
}

.btn-danger {
  background-color: #dc3545;
  color: white;
}

.btn-danger:hover {
  background-color: #c82333;
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
}

.loading-container p {
  margin-top: 15px;
  color: #666;
  font-size: 16px;
}

.alert {
  padding: 20px;
  border-radius: 4px;
  margin-bottom: 20px;
}

.alert-danger {
  background-color: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
}

.mt-3 {
  margin-top: 1rem;
}

/* Responsive */
@media (max-width: 992px) {
  .info-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .member-detail-container {
    padding: 15px;
  }

  .member-detail-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;
  }

  .header-left {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }

  .header-actions {
    width: 100%;
  }

  .header-actions .btn {
    flex: 1 1;
  }

  .member-detail-card {
    padding: 20px;
  }

  .profile-section {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  .profile-info h3 {
    font-size: 24px;
  }

  .profile-info .english-name {
    font-size: 18px;
  }

  .info-row {
    flex-direction: column;
    gap: 5px;
  }

  .info-label {
    min-width: auto;
    font-weight: 600;
  }
}

/* Modal Styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
}

.modal-content {
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  max-width: 500px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
}

.modal-header {
  padding: 20px;
  border-bottom: 1px solid #dee2e6;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-header h3 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #333;
}

.modal-close {
  background: none;
  border: none;
  font-size: 28px;
  line-height: 1;
  color: #6c757d;
  cursor: pointer;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: background-color 0.2s, color 0.2s;
}

.modal-close:hover {
  background-color: #f8f9fa;
  color: #333;
}

.modal-close:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.modal-body {
  padding: 20px;
}

.modal-body .form-group {
  margin-bottom: 20px;
}

.modal-body .form-group:last-child {
  margin-bottom: 0;
}

.modal-body label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  color: #333;
}

.modal-body .text-danger {
  color: #dc3545;
}

.modal-body .form-control {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  font-size: 14px;
  transition: border-color 0.2s;
}

.modal-body .form-control:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.modal-body .form-control:disabled {
  background-color: #e9ecef;
  cursor: not-allowed;
}

.modal-footer {
  padding: 20px;
  border-top: 1px solid #dee2e6;
  display: flex;
  gap: 10px;
  justify-content: flex-end;
}

.modal-footer .btn {
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
}

.modal-footer .btn-secondary {
  background-color: #6c757d;
  color: white;
}

.modal-footer .btn-secondary:hover:not(:disabled) {
  background-color: #5a6268;
}

.modal-footer .btn-primary {
  background-color: #007bff;
  color: white;
}

.modal-footer .btn-primary:hover:not(:disabled) {
  background-color: #0056b3;
}

.modal-footer .btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.btn-success {
  background-color: #28a745;
  color: white;
  margin-right: 5px;
}

.btn-success:hover {
  background-color: #218838;
}

@media (max-width: 768px) {
  .modal-content {
    max-width: 100%;
    margin: 20px;
  }

  .modal-footer {
    flex-direction: column;
  }

  .modal-footer .btn {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Members/MemberDetail.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,qCAAqC;EACrC,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,oBAAoB;EACpB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,SAAO;EACT;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;EACxC,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,cAAc;EACd,eAAe;EACf,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,gDAAgD;AAClD;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,aAAa;EACb,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":[".member-detail-container {\n  padding: 20px;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.member-detail-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 30px;\n}\n\n.header-left {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n}\n\n.btn-back {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  color: #007bff;\n  text-decoration: none;\n  font-weight: 500;\n  transition: color 0.2s;\n}\n\n.btn-back:hover {\n  color: #0056b3;\n}\n\n.header-titles {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.member-breadcrumb {\n  font-size: 13px;\n  color: #6b7280;\n}\n\n.member-breadcrumb a {\n  color: #2563eb;\n  text-decoration: none;\n}\n\n.member-breadcrumb a:hover {\n  text-decoration: underline;\n}\n\n.breadcrumb-sep {\n  color: #9ca3af;\n}\n\n.member-detail-header h2 {\n  font-size: 28px;\n  font-weight: 600;\n  color: #333;\n  margin: 0;\n}\n\n.header-actions {\n  display: flex;\n  gap: 10px;\n}\n\n.member-detail-card {\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n  padding: 30px;\n}\n\n.profile-section {\n  display: flex;\n  align-items: center;\n  gap: 30px;\n  padding-bottom: 30px;\n  margin-bottom: 30px;\n  border-bottom: 2px solid #e9ecef;\n}\n\n.profile-photo {\n  width: 150px;\n  height: 150px;\n  border-radius: 50%;\n  object-fit: cover;\n  border: 4px solid #e9ecef;\n}\n\n.profile-photo-placeholder {\n  width: 150px;\n  height: 150px;\n  border-radius: 50%;\n  background-color: #e9ecef;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 60px;\n  color: #6c757d;\n  border: 4px solid #dee2e6;\n}\n\n.profile-info h3 {\n  font-size: 32px;\n  font-weight: 600;\n  color: #333;\n  margin: 0 0 8px 0;\n}\n\n.profile-info .english-name {\n  font-size: 20px;\n  color: #666;\n  margin: 0 0 4px 0;\n}\n\n.profile-info .member-nickname {\n  font-size: 14px;\n  color: #6b7280;\n  margin: 0 0 10px 0;\n}\n\n.profile-info .badge {\n  margin: 0 8px 10px 0;\n}\n\n.profile-info .member-role-badge {\n  background: #e0f2fe;\n  color: #0369a1;\n}\n\n.profile-info .member-number {\n  font-size: 14px;\n  color: #666;\n  margin: 10px 0 0 0;\n}\n\n.profile-info .member-org-line {\n  font-size: 13px;\n  color: #666;\n  margin: 4px 0 0 0;\n  line-height: 1.35;\n}\n\n.profile-info .member-org-group {\n  font-size: 16px;\n}\n\n.profile-info .member-org-group .member-org-value {\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.profile-info .member-org-label {\n  margin-right: 4px;\n  color: #6b7280;\n}\n\n.profile-info .member-org-value {\n  color: #1f2937;\n  font-weight: 500;\n}\n\n.info-value-email,\n.info-row-email .info-value {\n  font-size: 12px;\n  color: #6b7280;\n}\n\n.profile-info .member-groups-text {\n  font-size: 11px;\n  font-weight: 400;\n  word-break: break-all;\n}\n\n.badge {\n  display: inline-block;\n  padding: 6px 12px;\n  border-radius: 12px;\n  font-size: 13px;\n  font-weight: 500;\n  text-transform: capitalize;\n}\n\n.badge-success {\n  background-color: #28a745;\n  color: white;\n}\n\n.badge-secondary {\n  background-color: #6c757d;\n  color: white;\n}\n\n.badge-warning {\n  background-color: #ffc107;\n  color: #212529;\n}\n\n.info-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 30px;\n  margin-bottom: 30px;\n}\n\n.info-section {\n  background: #f8f9fa;\n  padding: 20px;\n  border-radius: 6px;\n}\n\n.info-section h4 {\n  font-size: 18px;\n  font-weight: 600;\n  color: #495057;\n  margin: 0 0 15px 0;\n  padding-bottom: 10px;\n  border-bottom: 2px solid #dee2e6;\n}\n\n.info-row {\n  display: flex;\n  padding: 10px 0;\n  border-bottom: 1px solid #e9ecef;\n}\n\n.info-row:last-child {\n  border-bottom: none;\n}\n\n.info-label {\n  font-weight: 500;\n  color: #666;\n  min-width: 150px;\n  flex-shrink: 0;\n}\n\n.info-value {\n  color: #333;\n  word-break: break-word;\n}\n\n.info-value a {\n  color: #007bff;\n  text-decoration: none;\n}\n\n.info-value a:hover {\n  text-decoration: underline;\n}\n\n.notes-section {\n  background: #f8f9fa;\n  padding: 20px;\n  border-radius: 6px;\n  margin-bottom: 20px;\n}\n\n.notes-section h4 {\n  font-size: 18px;\n  font-weight: 600;\n  color: #495057;\n  margin: 0 0 15px 0;\n}\n\n.notes-section p {\n  color: #333;\n  line-height: 1.6;\n  margin: 0;\n  white-space: pre-wrap;\n}\n\n.system-info {\n  padding-top: 20px;\n  border-top: 1px solid #e9ecef;\n  text-align: center;\n}\n\n.system-info small {\n  color: #6c757d;\n  font-size: 13px;\n}\n\n.btn {\n  padding: 10px 20px;\n  border-radius: 4px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  border: none;\n  transition: all 0.2s;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  text-decoration: none;\n}\n\n.btn-primary {\n  background-color: #007bff;\n  color: white;\n}\n\n.btn-primary:hover {\n  background-color: #0056b3;\n}\n\n.btn-warning {\n  background-color: #ffc107;\n  color: #212529;\n}\n\n.btn-warning:hover {\n  background-color: #e0a800;\n}\n\n.btn-danger {\n  background-color: #dc3545;\n  color: white;\n}\n\n.btn-danger:hover {\n  background-color: #c82333;\n}\n\n.loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 20px;\n}\n\n.loading-container p {\n  margin-top: 15px;\n  color: #666;\n  font-size: 16px;\n}\n\n.alert {\n  padding: 20px;\n  border-radius: 4px;\n  margin-bottom: 20px;\n}\n\n.alert-danger {\n  background-color: #f8d7da;\n  color: #721c24;\n  border: 1px solid #f5c6cb;\n}\n\n.mt-3 {\n  margin-top: 1rem;\n}\n\n/* Responsive */\n@media (max-width: 992px) {\n  .info-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 768px) {\n  .member-detail-container {\n    padding: 15px;\n  }\n\n  .member-detail-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 15px;\n  }\n\n  .header-left {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 10px;\n  }\n\n  .header-actions {\n    width: 100%;\n  }\n\n  .header-actions .btn {\n    flex: 1;\n  }\n\n  .member-detail-card {\n    padding: 20px;\n  }\n\n  .profile-section {\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n  }\n\n  .profile-info h3 {\n    font-size: 24px;\n  }\n\n  .profile-info .english-name {\n    font-size: 18px;\n  }\n\n  .info-row {\n    flex-direction: column;\n    gap: 5px;\n  }\n\n  .info-label {\n    min-width: auto;\n    font-weight: 600;\n  }\n}\n\n/* Modal Styles */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 20px;\n}\n\n.modal-content {\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  max-width: 500px;\n  width: 100%;\n  max-height: 90vh;\n  overflow-y: auto;\n}\n\n.modal-header {\n  padding: 20px;\n  border-bottom: 1px solid #dee2e6;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.modal-header h3 {\n  margin: 0;\n  font-size: 20px;\n  font-weight: 600;\n  color: #333;\n}\n\n.modal-close {\n  background: none;\n  border: none;\n  font-size: 28px;\n  line-height: 1;\n  color: #6c757d;\n  cursor: pointer;\n  padding: 0;\n  width: 30px;\n  height: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n  transition: background-color 0.2s, color 0.2s;\n}\n\n.modal-close:hover {\n  background-color: #f8f9fa;\n  color: #333;\n}\n\n.modal-close:disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\n.modal-body {\n  padding: 20px;\n}\n\n.modal-body .form-group {\n  margin-bottom: 20px;\n}\n\n.modal-body .form-group:last-child {\n  margin-bottom: 0;\n}\n\n.modal-body label {\n  display: block;\n  margin-bottom: 8px;\n  font-weight: 500;\n  color: #333;\n}\n\n.modal-body .text-danger {\n  color: #dc3545;\n}\n\n.modal-body .form-control {\n  width: 100%;\n  padding: 10px 12px;\n  border: 1px solid #ced4da;\n  border-radius: 4px;\n  font-size: 14px;\n  transition: border-color 0.2s;\n}\n\n.modal-body .form-control:focus {\n  outline: none;\n  border-color: #007bff;\n  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n}\n\n.modal-body .form-control:disabled {\n  background-color: #e9ecef;\n  cursor: not-allowed;\n}\n\n.modal-footer {\n  padding: 20px;\n  border-top: 1px solid #dee2e6;\n  display: flex;\n  gap: 10px;\n  justify-content: flex-end;\n}\n\n.modal-footer .btn {\n  padding: 10px 20px;\n  border: none;\n  border-radius: 4px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.modal-footer .btn-secondary {\n  background-color: #6c757d;\n  color: white;\n}\n\n.modal-footer .btn-secondary:hover:not(:disabled) {\n  background-color: #5a6268;\n}\n\n.modal-footer .btn-primary {\n  background-color: #007bff;\n  color: white;\n}\n\n.modal-footer .btn-primary:hover:not(:disabled) {\n  background-color: #0056b3;\n}\n\n.modal-footer .btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.btn-success {\n  background-color: #28a745;\n  color: white;\n  margin-right: 5px;\n}\n\n.btn-success:hover {\n  background-color: #218838;\n}\n\n@media (max-width: 768px) {\n  .modal-content {\n    max-width: 100%;\n    margin: 20px;\n  }\n\n  .modal-footer {\n    flex-direction: column;\n  }\n\n  .modal-footer .btn {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
